// imove-behavior: 跳转创建

export default async function(ctx) {
  const redirect_url=`${encodeURIComponent(window?.location?.href)}`;
  ctx.emit('routerPage', `create?redirect_url=${redirect_url}`);
}